import { memo, FC, useState, useEffect } from 'react'
import { Icon } from 'mk-pc'
import { INavItem } from '@mk/core'
import { SubMenu } from './SubMenu'
import { AsideMenuContext, IAsideMenuContext } from './context'
import './index.scss'

interface Props {
  activeKey?: string
  expandKey?: string
  items?: Array<any>
  onSelect?: (e: INavItem) => void
}

/**
 * 侧边菜单
 */
export const AsideMenu: FC<Props> = memo((props) => {
  const { activeKey = '', expandKey = '', items = [], onSelect } = props

  const menuContext: IAsideMenuContext = {
    active: activeKey,
    expand: expandKey,
    onSelect: onSelect
  }

  return (
    <section className="aside-menu">
      <AsideMenuContext.Provider value={menuContext}>
        <ul>
          {items.map((item: INavItem) => {
            if (Array.isArray(item.children) && item.children.length > 0) {
              return <SubMenu key={item.id} item={item} />
            }

            return (
              <li
                key={item.id}
                className={activeKey === item.id ? 'aside-menu__item is-active' : 'aside-menu__item'}
                onClick={() => onSelect && onSelect(item)}
              >
                {item.icon && <Icon name={item.icon} size="20" />}
                <p className="name">{item.name}</p>
              </li>
            )
          })}
        </ul>
      </AsideMenuContext.Provider>
    </section>
  )
})
